export default function Error404(){
    return(
        <div style={{
            display: "flex",
            flexDirection:"column",
            justifyContent:"center",
            alignItems:"center",
            width: "100vw",
            height:"80vh"
        }}>
            <h1>Sorry!...But the page you are looking for is not found, or you are unauthorized</h1>
            <h2>Please try again!!!</h2>
        </div>
    )
}